import { NumericFormat } from 'react-number-format';

const FormikNumberFormat = ({ name, setFieldValue, ...props }) => {
    return (
        <NumericFormat
            {...props}
            onValueChange={(values) => {
                setFieldValue(name, values.value); // Use the name and setFieldValue props here
            }}
        />
    );
};

export default FormikNumberFormat;
